export default "__VITE_ASSET__8pB$UaA8__"